/**
 * @file CanvasTargetBar.tsx
 * @description Что показать на канве (phase19.16 Р2а; uiux-design-r2a §2,
 * §3): у каталога (экран, панель «Каталог», места над/под списком) —
 * «Показать: [Весь каталог ▾]», у шаблона страницы товара — полоса
 * «применяется к N товарам · Товар для примера ▾». У прочих — ничего.
 */

import { SITE_SLOTS } from "@chaiberi/shared";

import { useBuilder } from "../builder-context";
import { CatalogCategoryPicker } from "./CatalogCategoryPicker";
import { ProductTemplateBar } from "./ProductTemplateBar";

export function CanvasTargetBar() {
  const b = useBuilder();
  const { selection, pages } = b;
  if (selection.panel === null && selection.screen === "product") return <ProductTemplateBar />;
  const slot = pages.page?.kind === "SLOT" ? SITE_SLOTS.find((s) => s.key === pages.page?.slot) : null;
  const onCatalog = selection.panel === "catalog" || (selection.panel === null && (selection.screen === "catalog" || slot?.screen === "catalog"));
  if (!onCatalog) return null;
  return <CatalogCategoryPicker value={b.canvasTarget.category} onChange={(category) => b.setCanvasTarget({ ...b.canvasTarget, category })} />;
}
